export default "__VITE_ASSET__BRIZjM0e__"